import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UserCardSelectDropdownNotificationComponent } from './dropdown/select-user-cards-dropdown.component';

@Component({
    selector: 'app-form-select-user-cards',
    templateUrl: './select-user-cards.component.html',
    styleUrls: ['./select-user-cards.component.scss'],
})
export class UserCardFormSelectComponent implements OnInit {
    @Input() label: string;
    @Input() allLabel: string;
    @Input() useOptionAll = true;
    @Input() useOptionNew = false;
    @Input() newLabel: string;
    @Input() placeholder: string;

    private _options: {
        id: number;
        name: string;
        value: any;
    }[];

    private _selected = { id: '', name: '' };

    @Input()
    get selected() {
        return this._selected;
    }
    set selected(data) {
        this._selected = data;
    }

    @ViewChild(UserCardSelectDropdownNotificationComponent)
    public dropdown: UserCardSelectDropdownNotificationComponent;

    @Input()
    get options() {
        return this._options;
    }
    set options(data: any[]) {
        if (!data) {
            return;
        }
        if (this.useOptionAll) {
            this._options = [this.option_all, ...data];
        } else {
            this._options = [...data];
        }
    }

    @Output() selectChange = new EventEmitter();
    @Output() newClicked = new EventEmitter();

    get option_all() {
        return {
            id: '-1',
            name: this.allLabel,
        };
    }

    ngOnInit() {
        if (this.useOptionAll) {
            this.selected = this.option_all;
        } else {
            this.selected?.name ? this.select(this.selected) : (this.selected = { id: '', name: this.placeholder });
        }
    }

    select(option: any) {
        this.selected = option;
        this.selectChange.emit(this.selected);
        this.hideDropdown();
    }

    new() {
        this.newClicked.emit();
        this.hideDropdown();
    }

    public toggleDropdown(): void {
        this.dropdown.showing ? this.hideDropdown() : this.showDropdown();
    }

    public showDropdown() {
        this.dropdown.show();
    }

    public hideDropdown() {
        this.dropdown?.hide();
    }
}
